'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import Image from 'next/image'
import { cn } from '@/lib/utils'

const Wrapper = ({
  children,
  className,
  onClick
}: {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}) => {
  return (
    <div
      className={cn('relative mr-4 cursor-pointer', className)}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export const AgentStudioLogo = ({
  width,
  height,
  className,
  onClick
}: {
  width?: number
  height?: number
  className?: string
  onClick?: () => void
}) => {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // 在挂载前显示一个默认主题的图片
  if (!mounted) {
    return (
      <Wrapper className={className} onClick={onClick}>
        <Image
          src="/img/agentstudio-light.png"
          alt="agent-studio"
          width={width || 100}
          height={height || 18}
          priority
          className="object-contain"
        />
      </Wrapper>
    )
  }

  const url =
    resolvedTheme === 'dark'
      ? '/img/agentstudio-dark.png'
      : '/img/agentstudio-light.png'
  return (
    <Wrapper className={className} onClick={onClick}>
      <Image
        src={url}
        alt="agent-studio"
        width={width || 100}
        height={height || 18}
        priority
        className="object-contain"
      />
    </Wrapper>
  )
}
